module.exports = __webpack_public_path__ + "img/share-thumbnail.54944e4f.jpg";